<template>
  <div class="view-reset-password">
    <v-navigation-drawer permanent absolute :width="512">
      <v-container fill-height>
        <v-form
          @submit.prevent="resetPassword"
          ref="form"
          :lazy-validation="true"
          class="flex-grow-1 d-flex flex-column align-stretch"
        >
          <v-img
            class="align-self-center mb-9"
            src="@/assets/adequation-logo-square.svg"
            :width="250"
            :height="250"
            alt="Adequation"
          />
          <header class="mb-6 text-center">
            <h1 class="display-1">
              {{ $t("Réinitialiser") }}
            </h1>
            <p>
              {{
                $t(
                  "Entrez l’email sur lequel vous envoyer les informations pour réinitialiser votre mot de passe"
                )
              }}
            </p>
          </header>
          <v-alert v-if="message != null" :type="status">
            {{ message }}
          </v-alert>
          <v-text-field
            v-model="email"
            :label="$t('Email')"
            hide-details
            filled
            type="email"
            validate-on-blur
            :rules="[rules.email, rules.required]"
            required
            class="mb-4"
          />
          <v-btn
            type="submit"
            :disabled="!validForm"
            :loading="loading"
            color="primary"
            large
            rounded
            class="align-self-center mb-9"
            >{{ $t("Réinitialiser le mot de passe") }}</v-btn
          >
          <span class="align-self-center">
            {{ $t("Vous voulez vous connecter ?") }}
          </span>
          <v-btn
            class="align-self-center"
            text
            @click="
              () => {
                $router.push({ name: 'login' });
              }
            "
            >{{ $t("Se connecter") }}</v-btn
          >
          <div class="env" :class="env">
            <div>{{ env }}</div>
          </div>
        </v-form>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { RESET_PASSWORD } from "@/store/action-types";
const { mapActions: mapAuthActions } = createNamespacedHelpers(`auth`);

export default {
  data() {
    return {
      env: process.env.VUE_APP_API_ENV,
      token: this.$route.query.token,
      loading: false,
      message: null,
      status: null,
      validForm: true,
      email: "",
      rules: {
        required: value => !!value || this.$t("Requis."),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("Email invalide.");
        }
      }
    };
  },
  beforeMount() {
    // display error message
    if (this.token) {
      this.message = this.$t(
        "Le lien a expiré, veuillez recommencer votre demande."
      );
      this.status = "warning";
    }
  },
  methods: {
    ...mapAuthActions({
      reset: RESET_PASSWORD
    }),
    resetPassword() {
      this.loading = true;
      let callbackPath = this.$router.resolve({ name: "set-password" });
      this.reset({
        email: this.email,
        callbackUrl:
          window.location.protocol +
          "//" +
          window.location.host +
          callbackPath.href
      })
        .then(res => {
          if (res.status == "200") {
            this.message = this.$t(
              "Un email de réinitialisation vient de vous être envoyé."
            );
            this.status = "info";
          } else if (res.status == "204") {
            this.message = this.$t(
              "Cet adresse email ne correspond à aucun compte."
            );
            this.status = "warning";
          } else {
            this.message = this.$t("Une erreur a eu lieu. Veuillez réessayer.");
            this.status = "error";
          }
        })
        .catch(() => {
          this.message = this.$t("Une erreur a eu lieu. Veuillez réessayer.");
          this.status = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.view-reset-password {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url("~@/assets/login-background.jpg") no-repeat center right/cover;
}

.env {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(255, 255, 255);
  height: 96px;
  width: 96px;
  border-radius: 50%;

  position: absolute;
  left: 8px;
  bottom: 8px;
}

.LOCAL {
  background-color: #1ab5a9;
  opacity: 0.8;
}
.DEV,
.RCT {
  background-color: #4955bb;
  opacity: 0.8;
}
.PROD {
  background-color: rgb(255, 255, 255);
  visibility: hidden;
}
</style>
